<template>
  <div
    v-if="positioningData"
    class="speech-bubbles"
    :style="{
      top: `${positioningData.top}px`,
      left: `${positioningData.left}px`,
      width: `${positioningData.width}px`,
      height: `${positioningData.height}px`,
    }"
  >
    <div class="speech-bubbles-container">
      <WsDraggableSpeechBubble
        v-for="bubble in data"
        :key="bubble.id"
        :data="bubble"
        :type="type"
        :order="getOrder(Number(bubble.index))"
        :draggable-parts="draggableGapsSentenceParts(bubble)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.speech-bubbles {
  position: absolute;
}

.speech-bubbles-container {
  position: relative;
  width: 100%;
  height: 100%;
  font-size: clamp(16px, 2.1vw, 40px);
}
</style>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator';

import WsDraggableSpeechBubble from './WsDraggableSpeechBubble.vue';
import ActivityDraggableGaps from '../mixins/ActivityDraggableGaps.mixin';
import EventBus from '@/utils/helpers/EventBus';
import type { PositioningData } from '@/models/types/PositioningData';

@Component({
  components: {
    WsDraggableSpeechBubble,
  },
})
export default class ActivityWsSpeechBubbles extends Mixins(
  ActivityDraggableGaps,
) {
  private positioningData: PositioningData | null = null;

  public mounted() {
    EventBus.$on(
      'set-assets-hotspots-container-positioning',
      (data: PositioningData) => {
        this.positioningData = data;
      },
    );
  }

  public beforeDestroy() {
    EventBus.$off(
      'set-assets-hotspots-container-positioning',
      (data: PositioningData) => {
        this.positioningData = data;
      },
    );
  }
}
</script>
